import { APP_TYPE } from 'constants/ui';
import React from 'react';
import {
  requestSelectors,
  useZustandRequestKitStore,
  HookProvider,
  ERegistrationFlow,
} from 'react-gldn-kit';
import {
  useTransportControllers,
  useCurrencies,
  useCountryInfo,
  api,
} from 'react-render-hooks';

import { prepareRegistrationData } from 'utils/transport/rest';

type Props = {
  children: React.ReactElement;
};

export const LogicModalProvider = ({ children }: Props) => {
  const { sendCommand } = useTransportControllers();

  const addRequestId = useZustandRequestKitStore(
    requestSelectors.addRequestKeyForLoaderAction
  );

  const sendRegistrationCommand =
    (type: (typeof ERegistrationFlow)[keyof typeof ERegistrationFlow]) =>
    async (key: string, data: any) => {
      if (ERegistrationFlow[type] === ERegistrationFlow.Rest) {
        const sendData = prepareRegistrationData(data);

        if (data.requestId) {
          addRequestId(data.requestId);
        }
        const response = await api.registration(
          'https://wss.22kk.club/21610/client/registration',
          sendData
        );

        if (data.requestId) {
          useZustandRequestKitStore.getState().removeKey(data.requestId);
        }

        if (response) {
          // Need to sign in by token
          // authFlow(response.token);
        }

        return;
      }

      sendCommand(key, data, true);
    };

  return (
    <HookProvider
      value={{
        useTransportControllers,
        useCurrencies,
        useCountryInfo,
        sendRegistrationCommand,
        appType: APP_TYPE,
      }}
    >
      {children}
    </HookProvider>
  );
};
